import Metadata from "../../requests/apa/Metadata";
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import ChannelSingleton from '../../components/Epg/ChannelsSingleton';
import Utils from './../../utils/Utils'

let enableTimeShiftEvent =  false;
let enableTrickMode =  false; // speed 2X, 4X, 8X, 16X ...

// Metadata value, key name: fast_forward_rewind_option
// IMPORTANTE: El array NO debe incluir la velicidad normal de reproducción (que podría ser valor "0" en la posición 0 del array de abajo)
// sólo incluir en el array las opciones válidas de trickplay
// Si viene options como array, está activo, si viene como null, esta inactivo
//const metadataFastForwardRewindDefaultValue = '{"default": { "options": null}, "colombia": {"options": "2,4,8,16,32,64"}}';
const metadataFastForwardRewindDefaultValue = '{"default": { "enable": false, "options": ""}, "colombia": {"enable": false, "options": [2,4,8,16,32,64]}}';
const metadataSeekOnTSDefaultValue = '{"default": { "startover": false, "catchup": false, "npvr": false}}';

/**
 * This method uses "TS" term to refer to catchup, startover and npvr
 */
const isSeekOnTSEnabled = function(streamType) {
    let enabled = false;
    const meta =  Metadata.get("seek_on_ts", metadataSeekOnTSDefaultValue);

    const objectMeta = JSON.parse(meta);

    const region = DeviceStorage.getItem('region');
    const value = (objectMeta[region]) ? objectMeta[region] : objectMeta['default'];

    if(Utils.isObject(value) && Utils.isNotNullOrNotUndefined(value[streamType])) {
        enabled = value[streamType];
    }

    return enabled;
}

const fastForwardRewindOptions = function() {
    try {
        const meta =  Metadata.get("fast_forward_rewind_option", metadataFastForwardRewindDefaultValue);
        const objectMeta = JSON.parse(meta);
        var _region = DeviceStorage.getItem('region');
        const value = (objectMeta[_region]) ? objectMeta[_region] : objectMeta['default'];

        console.log('[SPEED PLAYER] EventTimeshift > options ' + value);

        if(value && (typeof value == 'object') && value.enable) {
            if(value.enable === true) {
                if(value.options.length > 0) {
                    return value.options;
                }
                else {
                    return null;
                }
            }
            else {
                return null;
            }
        }
        else {
            return null;
        }
    } catch (e) {
        console.log('[SPEED PLAYER] EventTimeshift > options CATCH ' + JSON.stringify(e));
        return null;
    }
};

const init = function() {

    enableTimeShiftEvent =  Utils.getApaMetadataKey("eventTimeshift", '{"enable":false}', 'enable');

    // Revisar por el Trick mode, habilitado o no
    const optionsTrickMode = fastForwardRewindOptions();
    enableTrickMode = Array.isArray(optionsTrickMode);
};

const packageWithTimeshift = async function() {
  let maxTimeshiftAllow = await new ChannelSingleton().getMaxTimeshift();
  return !isNaN(maxTimeshiftAllow) && maxTimeshiftAllow > 0;
};

const isEnabled = function() {
  // DobleCheck, a petición de Mike:
  // Si no viene la llave de timeshift nueva experiencia,
  // entonces se verifica que los paquetes del usuario tengan timeshift y
  // si es así, se lanza esta nueva experiencia de timeshift por evento por default
  if (!enableTimeShiftEvent) {
    enableTimeShiftEvent = packageWithTimeshift();
  }

  return enableTimeShiftEvent;
};

const isTrickModeEnabled = function() {
    return enableTrickMode;
};

const EventTimeshift = {
    init,
    isEnabled,
    fastForwardRewindOptions,
    isTrickModeEnabled,
    isSeekOnTSEnabled
};

export default EventTimeshift;



// WEBPACK FOOTER //
// ./src/AAF/Timeshift/EventTimeshift.js